<style lang="less" scoped>
    .margin-tb{
        height:32px;
        margin-top: 4px;
    }
    .query-title-div{
        width: 90px !important;
    }

    .list-num-div{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 24px;

        .list-num-div-item{
            display: flex;
            flex-direction: column;
            align-items: center;

            .item-title{
                font-size: 14px;
                color: #999999;
            }

            .item-num{
                font-size: 20px;
                color: #333;
            }
        }
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">对账订单管理</div>
            <ZD-list-querys>
                <template slot="inputs">
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">充电时间</div>
                        <div class="query-inputs-div flex-1">
                            <el-date-picker class="full-width" v-model="searchChargeTime" :picker-options="pickerOptions"
                                            style="width:340px;" type="datetimerange" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                                            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                            @change="handleChargeDateChange"></el-date-picker>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">订单编号</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.orderNo" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                        </div>
                    </div>
                </template>
                <template  slot="actions">
                    <div class="">
                        <button class="common-bg-button" @click="getListData(pagination, false)">搜 索</button>
                        <button class="common-empty-button" @click="reset()">重 置</button>
                    </div>
                </template>
            </ZD-list-querys>
            <!-- 数据展示 -->
            <div class="list-num-div">
                <div class="list-num-div-item" v-for="(item, index) in numList" :key="index">
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-num">{{ item.num }}</div>
                </div>
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates"
                          :tableData="tableData" :tableConfig="pageConfig.tableConfigList" :selections="selections"
                          v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import pageConfig from './page-config';
export default {
    data() {
        return {
            pageConfig: pageConfig, // 页面配置
            tableData: [], // 表格数据
            selections: [], // 表格选项
            pagination: pageConfig.paginationList,
            queryInfo: {
                orderNo: '',
                beginTime:'',
                endTime: '',
            },
            operates: {
                width: 180,
                fixed: "right",
                list: [
                    {
                        id: "report",
                        label: "详情",
                        type:"primary",
                        show: true,
                        disabled: false,
                        method: (index, row) => {
                            // this.$store.commit('setEditId', row.id)
                            // this.$router.push({
                            // 	name: pageConfig.orderDeatilRouter
                            // });
                            this.toDetail(row.id)
                        }
                    },
                ]
            }, // 列操作按钮
            searchChargeTime: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '当月累计',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        const month = start.getMonth()+1;
                        start.setDate(1);
                        if (month===1 || month===3 || month===5 || month===7 || month===8 || month===10 ||month===12) {
                            end.setDate(31);
                        }
                        if (month===4 || month===6 || month===9 || month===11) {
                            end.setDate(30);
                        }
                        if (month===2) {
                            const year = start.getFullYear();
                            if ((year % 4 == 0 && !(year % 100 == 0)) || year % 400 == 0) {
                                end.setDate(29);
                            } else {
                                end.setDate(28);
                            }
                        }
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '当年累计',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(0);
                        start.setDate(1);
                        end.setMonth(11);
                        end.setDate(31);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            numList: [
                {
                    title: '累计订单量（单）',
                    num: '33，333',
                },
                {
                    title: '累计用电量（度）',
                    num: '33，333',
                },
                {
                    title: '累计总收入（元）',
                    num: '33，333',
                },
                {
                    title: '累计服务费（元）',
                    num: '33，333',
                },
                {
                    title: '累计电费（元）',
                    num: '33，333',
                },
            ],
        }
    },
    methods: {
        init() {
            if(this.$route.query.mobile){
                this.queryInfo.phoneNum = this.$route.query.mobile;
            };
            if(this.$route.query.stationNo){
                this.queryInfo.stationNo = this.$route.query.stationNo;
            }
            this.getListData(this.pagination,true);
        },
        // 获取表格数据
        getListData(pagination, reload = false) {
            let _ = this;
            _.$U.showLoading(_);
            _.queryInfo.pageNum = pagination.current - 1;
            if (reload) {
                this.pagination.current = 1;
                _.queryInfo.pageNum = 0;
            }
            _.queryInfo.pageSize = pagination.pageSize;
            _.queryInfo.corpNo = _.$store.state.corpNo;
            _.$H.get(_, _.$A.order.pileorder, _.queryInfo).then(res => {
                _.tableData = res.data.data.content || [];
                _.pagination.total = res.data.data.totalElements || 0;
                _.$U.hideLoading(_);
            })
        },
        handleChargeDateChange(val){
            if (val) {
                this.queryInfo.beginTime = val[0];
                this.queryInfo.endTime = val[1];
            } else {
                delete this.queryInfo.beginTime;
                delete this.queryInfo.endTime;
            }
        },
        toDetail(val){
            let _ = this;
            var url = _.$router.resolve({name: 'orderReconciliationDetail',query: {id: val}})
            window.open(url.href,'_blank')
        },
        reset(){
            this.pagination.current = 1;
            this.searchChargeTime = [];
            this.queryInfo = {
                orderNo: '',
                beginTime:'',
                endTime: '',
            }
            this.getListData(this.pagination,true);
        }
    },
    mounted() {
        this.init();
    }
}
</script>
